import React, { memo } from 'react';
import { Text } from '../../components';
import './Button.scss';

type ButtonProps = {
  label: string,
  onClick: () => void,
  isLoading?: boolean,
  isDisabled?: boolean,
  className?: string,
  size?: 'sm' | 'md' | 'lg',
  variant?: "filled" | "outlined",
}

export const Button = memo(
  function Button(props: ButtonProps) {
    const {
      label,
      onClick,
      isLoading,
      isDisabled,
      className,
      size = "lg",
      variant = "filled"
    } = props;

    return (
      <button
        onClick={onClick}
        className={`custom-btn background-second-color ${className} ${size}-btn variant-${variant}`}
        disabled={isDisabled || isLoading}
      >
        <Text variant="content2" weight={700} align="center">
          {label}
        </Text>
      </button>
    );
  }
);